import { render, staticRenderFns } from "./StorageLocations.vue?vue&type=template&id=5374dcb6&scoped=true&"
import script from "./StorageLocations.vue?vue&type=script&lang=js&"
export * from "./StorageLocations.vue?vue&type=script&lang=js&"
import style0 from "./StorageLocations.vue?vue&type=style&index=0&id=5374dcb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374dcb6",
  null
  
)

export default component.exports